import React from 'react';
import NoteAddRoundedIcon from '@material-ui/icons/NoteAddRounded';
import strings from 'strings';
import FPIconButton from 'UI/components/atoms/FPIconButton';

export const CreateMultipleNotesButton = ({ onClick }) => {
  return (
    <FPIconButton
      onClick={onClick}
      showTooltipWhenDisabled
      icon={NoteAddRoundedIcon}
      tooltipProps={{
        arrow: false,
        placement: 'bottom',
        title: strings.inventory.shared.listing.addNotes
      }}
      iconProps={{
        onSetColor: ({ primary }) => primary.main
      }}
    />
  );
};
